import $ from 'jquery'
import Swiper from 'swiper/bundle'
import { Fancybox } from '@fancyapps/ui'

Fancybox.bind('[data-fancybox="videos-gallery"]', {
  Thumbs: {
    type: 'classic',
  },
})

const initializeBlock = function ($block) {
  const wrapper = $block.find('.videos-block__videos')

  if (!wrapper.length) {
    return
  }

  new Swiper(wrapper[0], {
    spaceBetween: 15,
    slidesPerView: 1.2,
    breakpoints: {
      475: {
        spaceBetween: 15,
        slidesPerView: 1.5,
      },
      992: {
        spaceBetween: 15,
        slidesPerView: 2,
      },
      1200: {
        spaceBetween: 15,
        slidesPerView: 2.5,
      },
    },
  })
}

$('.videos-block').each(function () {
  initializeBlock($(this))
})

if (window.acf) {
  window.acf.addAction('render_block_preview/type=smat-videos', initializeBlock)
}
